import React from "react";

export default function OpenQuestionStep({
  canContinue,
  canGoBack,
  failed,
  onBack,
  onContinue,
  onSkip,
  onTextChange,
  question,
  submitting,
  text
}) {
  return (
    <div className="survey-step">
      <h2 className="survey-headline">{question.headline}</h2>
      {question.explanation && (
        <p className="survey-explanation">{question.explanation}</p>
      )}
      <div className="survey-textarea-wrap">
        <textarea
          className="survey-textarea"
          disabled={submitting}
          maxLength={question.maxLength}
          onChange={(event) => onTextChange(event.target.value)}
          placeholder="Type your answer here ..."
          rows={5}
          value={text}
        />
        <span className="survey-counter">{text.length} / {question.maxLength}</span>
      </div>
      {failed && (
        <p className="survey-error">Sorry, something went wrong. Please try again.</p>
      )}
      <div className="survey-actions">
        {canGoBack && (
          <button className="survey-back joystix" disabled={submitting} onClick={onBack} type="button">
            Back
          </button>
        )}
        {!question.mandatory && text.trim().length === 0 ? (
          <button className="survey-back joystix" disabled={submitting} onClick={onSkip} type="button">
            Skip
          </button>
        ) : (
          <button
            className="survey-continue joystix"
            disabled={!canContinue || submitting}
            onClick={onContinue}
            type="button"
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
}
